export enum Status {
	DELIVERED = 'Delivered',
	FAILED = 'Failed',
}
